import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  conditionIcon: {
    minWidth: 35,
  },
  conditionName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '20ch',
  },
  activeIcon: {
    color: theme.palette.success.dark,
  },
}));

export default useStyles;
